(function () {
  class RoyalSymbolAnimator extends PIXI.Container {
    constructor() {
      super();
      this.visible = false;
      this._trackInfo = undefined;
      this._animTime = 700;
      this._movieScale = { x: 1.0, y: 1.0 };
      Reflex.registerEventHandler(
        "orientationChange",
        this.onOrientationChange.bind(this)
      );
    }

    play(trackInfo, loop, onCellAnimFinishedCb) {
      this._trackInfo = trackInfo;
      const self = this;

      const stake = gameController.getCurrentModeStake();

      if (gameController.inFreeSpins || gameController.reelsPrize > stake) {
        this.initialiseSymbolMovie(trackInfo.symbolId, trackInfo.getPosition());
        trackInfo.showSymbol(false);

        if (this._bgMovie) {
          this._bgMovie.gotoAndPlay(0);
        }
        timerManager.addTimer(
          this._animTime,
          function (progress) {
            let scale = 1 + Math.sin(Math.PI * progress) * 0.25;
            self._movie.scale.set(
              self._movieScale.x * scale,
              self._movieScale.y * scale
            );
          },
          function () {
            self._movie.scale.set(self._movieScale.x, self._movieScale.y);
            onCellAnimFinishedCb(self);
          }
        );
      } else {
        this.initialiseSymbolMovie(trackInfo.symbolId, trackInfo.getPosition());
        if (this._bgMovie) {
          this._bgMovie.visible = false;
        }
        trackInfo.showSymbol(false);
        timerManager.addTimeout(1000, function () {
          onCellAnimFinishedCb(self);
        });
      }

      gameController.winlineAnimator.winAnim(self._movie);
    }

    initialiseSymbolMovie(symbolId, symPos) {
      this.visible = true;
      if (this._bgMovie) {
        this._bgMovie.gotoAndStop(0);
      }
      this._movie.gotoAndStop(symbolId);
      this.position.set(
        symPos.x + this._positionOffset.x,
        symPos.y + this._positionOffset.y
      );
    }

    getTrackInfo() {
      return this._trackInfo;
    }

    finalise() {
      this.visible = false;
      this._trackInfo.showSymbol(true);
      this._trackInfo = undefined;
    }

    untrack() {
      if (this._trackInfo) {
        this._trackInfo.untrack();
      }
    }

    skip() {
      this.untrack();
    }

    onOrientationChange() {
      if (this._trackInfo !== undefined) {
        let symPos = this._trackInfo.getPosition();
        this.position.set(
          symPos.x + this._positionOffset.x,
          symPos.y + this._positionOffset.y
        );
        this._movie.scale.set(this._movieScale.x, this._movieScale.y);
      }
    }
  }

  let create = function () {
    return new RoyalSymbolAnimator();
  };

  let initialise = function (json, instance) {
    instance._bgMovie = undefined;
    if (json.playData.includeBgAnim) {
      instance._bgMovie = resourceManager.createObject(
        "movie",
        "bgAnim",
        instance.name,
        {
          definition: "Symbol_BgWin",
        }
      );
      instance._bgMovie.loop = 0;
      instance._bgMovie.gotoAndStop();
      instance._bgMovie.anchor.set(0.5);
    }
    instance._movie = resourceManager.createObject(
      "movie",
      "staticSymbols",
      instance.name,
      {
        definition: "staticSymbols",
      }
    );
    instance._positionOffset = { x: 0, y: 0 };
    if (json.playData.posOffset) {
      instance._positionOffset = json.playData.posOffset;
    }
    if (json.playData.scale) {
      instance._movieScale = {
        x: json.playData.scale.x,
        y: json.playData.scale.y,
      };
      instance._movie.scale.set(json.playData.scale.x, json.playData.scale.y);
    }
    if (json.playData.animTime) {
      instance._animTime = json.playData.animTime;
    }
    instance._movie.anchor.set(0.5);
  };

  let getRequiredFiles = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "RoyalSymbolAnimator",
    create,
    initialise,
    getRequiredFiles
  );
})();
